// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VxpN","field":"styles_field__3qjid","fieldCol":"styles_fieldCol__wSkoV","diffCol":"styles_diffCol__24-N0","diff":"styles_diff__2_1xT"};